import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { DAYS, MONTHS, YEARS } from 'shared/constants';
import { Select } from 'shared/components/Form';
import ErrorMessage from 'shared/components/ErrorMessage';
import styles from './DateSelect.module.scss';

const DateSelect = ({ id, label, day, daySelectName, invalidDay, month, monthSelectName, invalidMonth, year, yearSelectName, invalidYear, allowEmpty, error, disabled, onChange, children }) => {
  const { t } = useTranslation('common');

  const months = MONTHS.map(({ value }) => ({ value, label: daySelectName === null ? t(`month.${value}`) : t(`monthInflected.${value}`) }));
  const invalidDate = invalidDay || invalidMonth || invalidYear || error !== null;
  const idSuffix = id || Math.round(Math.random() * 10000);

  return (
    <div className={styles.dateSelect}>
      {label !== null && (
        <label htmlFor={`${daySelectName || monthSelectName}-${idSuffix}`} className={invalidDate ? `${styles.error} error` : ''}>{label}</label>
      )}
      {daySelectName !== null && (
        <Select id={`${daySelectName}-${idSuffix}`} name={daySelectName} options={DAYS} value={day} emptyValueLabel={allowEmpty ? '' : null} onChange={onChange} error={invalidDay} disabled={disabled} />
      )}
      <Select id={`${monthSelectName}-${idSuffix}`} name={monthSelectName} options={months} value={month || ''} emptyValueLabel={allowEmpty ? '' : null} onChange={onChange} error={invalidMonth} disabled={disabled} />
      <Select id={`${yearSelectName}-${idSuffix}`} name={yearSelectName} options={YEARS} value={year || ''} emptyValueLabel={allowEmpty ? '' : null} onChange={onChange} error={invalidYear} disabled={disabled} className={styles.year} />
      {children}
      {invalidDate && <ErrorMessage>{error || t('validation.invalidDate')}</ErrorMessage>}
    </div>
  );
};

DateSelect.propTypes = {
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  day: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  daySelectName: PropTypes.string,
  invalidDay: PropTypes.bool,
  month: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  monthSelectName: PropTypes.string,
  invalidMonth: PropTypes.bool,
  year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  yearSelectName: PropTypes.string,
  invalidYear: PropTypes.bool,
  allowEmpty: PropTypes.bool,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  children: PropTypes.element
};

DateSelect.defaultProps = {
  id: null,
  label: null,
  day: 0,
  daySelectName: 'day',
  invalidDay: false,
  month: 0,
  monthSelectName: 'month',
  invalidMonth: false,
  year: 0,
  yearSelectName: 'year',
  invalidYear: false,
  allowEmpty: true,
  error: null,
  disabled: false,
  onChange() {},
  children: null
};

export default DateSelect;
